import { Box, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

import Textarea from '_app/components/Form/Textarea'
import useCart from '_app/hooks/useCart'

const CartCommentsToOrder = () => {
  const { t } = useTranslation('cart')
  const { orderComment, setOrderComment } = useCart()
  const [cartNote, setCartNote] = useState('')
  const numberOfLines = cartNote.split(/\r\n|\r|\n/).length

  useEffect(() => {
    if (orderComment) {
      setCartNote(orderComment?.startsWith('###') ? orderComment?.slice(3) : orderComment)
    }
  }, [orderComment])

  return (
    <Box
      width="100%"
      bgColor="#fff"
      border="solid 1px"
      borderColor="borderLight"
      p={6}
    >
      <Text fontSize="xs" fontWeight="light">
        {t('ORDER_COMMENTS')}
      </Text>
      <Textarea
        placeholder={t('ORDER_NOTES')}
        value={cartNote}
        onChange={e => setCartNote(e.target.value)}
        onBlur={e => setOrderComment(e.target.value)}
        rows={numberOfLines}
      />
    </Box>
  )
}

export default CartCommentsToOrder
